import { RestBase } from './base'

export class RestFile {
  private rest: RestBase

  constructor() {
    this.rest = new RestBase()
  }

  public profile(token: string, file: File, partyId: number) {
    const form = new FormData()
    form.append('file', file)

    return this.rest.post(`/api/parties/${partyId}/uploads/profile`, { headers: this.rest.bearerAuthorizationHeader(token), body: form })
  }

  public profileUserId(file: File, partyId: number, userId: number) {
    const form = new FormData()
    form.append('file', file)

    return this.rest.post(`/api/parties/${partyId}/uploads/profile/${userId}`, { withCmsAuth: true, body: form })
  }

  public profileGrant(file: File, partyId: number) {
    const form = new FormData()
    form.append('file', file)

    return this.rest.post(`/api/parties/${partyId}/uploads/admin/profile`, { withCmsAuth: true, body: form })
  }

  public media(token: string, file: File, partyId: number) {
    const form = new FormData()
    form.append('file', file)

    return this.rest.post(`/api/parties/${partyId}/uploads/media`, { body: form, headers: this.rest.bearerAuthorizationHeader(token) })
  }
}
